import { useEffect, useRef, useState } from 'react'
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'

const getExtension = (fileUrl, extension) => {
  if (extension) return extension.toLowerCase().replace(/^\./, '')
  try {
    const pathname = new URL(fileUrl).pathname
    const match = /\.([a-zA-Z0-9]+)$/.exec(pathname)
    return match ? match[1].toLowerCase() : ''
  } catch {
    return ''
  }
}

// The static viewer rejects a cross-origin `?file=` query param (pdf.js
// blocks it to stop the hosted viewer being used as an open proxy), so the
// SAS-token URL is handed to PDFViewerApplication.open() directly instead.
const PdfJsViewer = ({ fileUrl, height }) => {
  const iframeRef = useRef(null)
  const [viewerReady, setViewerReady] = useState(false)

  useEffect(() => {
    if (!viewerReady || !fileUrl) return
    iframeRef.current?.contentWindow?.PDFViewerApplication?.open({
      url: fileUrl
    })
  }, [viewerReady, fileUrl])

  const handleLoad = () => {
    const app = iframeRef.current?.contentWindow?.PDFViewerApplication
    app?.initializedPromise.then(() => setViewerReady(true))
  }

  return (
    <div style={{ width: '100%', height }}>
      <iframe
        ref={iframeRef}
        src='/pdfviewer/web/viewer.html'
        width='100%'
        height='100%'
        title='PDF Viewer'
        frameBorder='0'
        onLoad={handleLoad}
      />
    </div>
  )
}

export const DocumentViewer = ({ fileUrl, extension, height = '800px' }) => {
  if (getExtension(fileUrl, extension) === 'pdf') {
    return <PdfJsViewer fileUrl={fileUrl} height={height} />
  }

  return (
    <DocViewer
      pluginRenderers={DocViewerRenderers}
      documents={[{ uri: fileUrl }]}
      config={{ header: { disableFileName: true } }}
      style={{ width: '100%', height }}
    />
  )
}
